import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * The two-pane split (PRD FR-6.7).
 *
 * Persisted because it is a working preference, not a page state: someone who
 * drags the divider to give charts more room means it for the next question
 * too. The bounds are the PRD's — 32% to 68% — so neither pane can be dragged
 * into uselessness.
 */

export const MIN_SPLIT = 32;
export const MAX_SPLIT = 68;

export type WorkspaceTab = "conversation" | "artifacts";

interface WorkspaceState {
  /** Conversation width, as a percentage of the workspace. */
  split: number;
  /** Which pane a narrow viewport is showing (PRD FR-6.7, mobile tabs). */
  tab: WorkspaceTab;
  setSplit: (split: number) => void;
  setTab: (tab: WorkspaceTab) => void;
}

export function clampSplit(value: number): number {
  return Math.min(MAX_SPLIT, Math.max(MIN_SPLIT, Math.round(value)));
}

export const useWorkspace = create<WorkspaceState>()(
  persist(
    (set) => ({
      split: 58,
      tab: "conversation",
      setSplit: (split) => set({ split: clampSplit(split) }),
      setTab: (tab) => set({ tab }),
    }),
    {
      name: "ming.workspace",
      partialize: (state) => ({ split: state.split }),
    },
  ),
);
